import { render, staticRenderFns } from "./DocumentPortalItem.vue?vue&type=template&id=e01515d6&scoped=true&"
import script from "./DocumentPortalItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalItem.vue?vue&type=style&index=0&id=e01515d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01515d6",
  null
  
)

export default component.exports